/* Search lifecycle, predictive results and recent searches. */
(function () {
  'use strict';
  if (window.jbSearchReady) return;
  window.jbSearchReady = true;
  var disposeSearch;
  function initializeSearch() {
    if (disposeSearch) disposeSearch();
    var panel = document.getElementById('jb-search');
    if (!panel) return;
    var input = document.getElementById('jb-search-input');
    var overlay = document.getElementById('jb-search-overlay');
    var form = document.getElementById('jb-search-form');
    var defaults = document.getElementById('jb-search-default');
    var results = document.getElementById('jb-search-results');
    var columns = document.getElementById('jb-search-results-cols');
    var creations = document.getElementById('jb-search-results-creations');
    var productsEl = document.getElementById('jb-search-results-products');
    var more = document.getElementById('jb-search-more-link');
    var progress = document.getElementById('jb-search-loading');
    var status = document.getElementById('jb-search-status');
    var historyEl = document.getElementById('jb-search-history');
    var historyLinks = document.getElementById('jb-search-history-links');
    var header = document.querySelector('.header-section .header');
    var triggers = document.querySelectorAll('.jb-header-search, .jb-drawer__mobile-search, .jb-panel-header__search-trigger');
    var lifecycle = new AbortController();
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var mobile = window.matchMedia('(max-width: 767px)');
    var headerSurface = null;
    if (header) {
      headerSurface = document.createElement('span');
      headerSurface.className = 'jb-search-header-surface';
      headerSurface.setAttribute('aria-hidden', 'true');
      header.prepend(headerSurface);
    }
    var state = 'closed', opener, closingTimer, debounceTimer, request, lastQuery = '', contentAnimation;
    var historyKey = 'jb-search-history-v1';
    var searchUrl = panel.dataset.searchUrl || '/search';
    var predictiveUrl = panel.dataset.predictiveUrl || '/search/suggest';
    function listen(target, type, handler) {
      if (target) target.addEventListener(type, handler, { signal: lifecycle.signal });
    }
    function syncPosition() {
      var top = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      panel.style.setProperty('--jb-search-top', top + 'px');
      overlay.style.setProperty('--jb-search-top', top + 'px');
    }
    function urlFor(query) {
      return searchUrl + '?q=' + encodeURIComponent(query) + '&options%5Bprefix%5D=last';
    }
    function safeUrl(value) {
      try {
        var url = new URL(value, window.location.origin);
        return url.origin === window.location.origin ? url.pathname + url.search + url.hash : '';
      } catch (_) { return ''; }
    }
    function esc(value) {
      return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function highlight(title, query) {
      var parts = String(title || '').split(new RegExp('(' + query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi'));
      return parts.map(function (part, i) { return i % 2 ? '<strong>' + esc(part) + '</strong>' : esc(part); }).join('');
    }
    function history() {
      try {
        var items = JSON.parse(localStorage.getItem(historyKey) || '[]');
        return Array.isArray(items) ? items.filter(function (x) { return typeof x === 'string' && x.length <= 120; }).slice(0, 5) : [];
      } catch (_) { return []; }
    }
    function showHistory() {
      var items = history();
      historyLinks.innerHTML = items.map(function (q) { return '<a href="' + esc(urlFor(q)) + '">' + esc(q) + '</a>'; }).join('');
      historyEl.hidden = !items.length || !!input.value.trim();
    }
    function remember(query) {
      if (!query) return;
      var q = query.slice(0, 120);
      try { localStorage.setItem(historyKey, JSON.stringify([q].concat(history().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); })).slice(0, 5))); } catch (_) { /* Search works with storage unavailable. */ }
    }
    function cancelRequest() {
      if (request) { clearTimeout(request.timer); request.controller.abort(); request = null; }
      progress.hidden = true;
      panel.removeAttribute('aria-busy');
    }
    function animateContent(update) {
      if (contentAnimation) contentAnimation.cancel();
      var oldHeight = panel.getBoundingClientRect().height;
      panel.style.height = '';
      update();
      var newHeight = panel.getBoundingClientRect().height;
      if (!reduced.matches && state === 'open' && panel.animate && Math.abs(oldHeight - newHeight) > 1) {
        contentAnimation = panel.animate([{ height: oldHeight + 'px' }, { height: newHeight + 'px' }], { duration: 360, easing: 'cubic-bezier(.22,1,.36,1)' });
      }
    }
    function showDefault() {
      animateContent(function () { defaults.hidden = false; results.hidden = true; showHistory(); });
      status.textContent = '';
    }
    function finishClose() {
      if (state !== 'closing') return;
      state = 'closed';
      panel.classList.remove('is-open', 'is-closing');
      panel.setAttribute('aria-hidden', 'true');
      overlay.classList.remove('is-open', 'is-closing');
      if (header) header.classList.remove('jb-search-header', 'jb-search-header-open');
      document.body.classList.remove('jb-search-open');
      input.value = ''; lastQuery = ''; opener = null;
      showDefault();
    }
    function openSearch(trigger) {
      if (state === 'open') return;
      var fresh = state === 'closed';
      clearTimeout(closingTimer);
      opener = trigger || document.activeElement;
      document.dispatchEvent(new CustomEvent('jb:search-open'));
      if (header) header.classList.add('jb-search-header');
      syncPosition();
      if (fresh) { input.value = ''; lastQuery = ''; showDefault(); }
      panel.setAttribute('aria-hidden', 'false');
      panel.removeAttribute('inert');
      panel.classList.remove('is-closing');
      overlay.classList.remove('is-closing');
      // Establish the closed frame before starting the reversible CSS transition.
      void panel.offsetHeight;
      state = 'open';
      if (header) header.classList.add('jb-search-header-open');
      panel.classList.add('is-open');
      overlay.classList.add('is-open');
      document.body.classList.add('jb-search-open');
      triggers.forEach(function (el) { el.setAttribute('aria-expanded', 'true'); });
      if (mobile.matches) {
        // Keep the mobile creation previews visible until the visitor taps the field.
        panel.tabIndex = -1;
        panel.focus({ preventScroll: true });
      } else input.focus({ preventScroll: true });
      if (!fresh && input.value.trim()) queueSearch();
    }
    function closeSearch(restoreFocus) {
      if (state !== 'open') return;
      state = 'closing';
      clearTimeout(debounceTimer); cancelRequest();
      if (contentAnimation) contentAnimation.cancel();
      if (restoreFocus !== false && opener && opener.isConnected) opener.focus({ preventScroll: true });
      else if (panel.contains(document.activeElement)) document.activeElement.blur();
      panel.setAttribute('inert', '');
      panel.classList.add('is-closing');
      overlay.classList.add('is-closing');
      if (header) header.classList.remove('jb-search-header-open');
      triggers.forEach(function (el) { el.setAttribute('aria-expanded', 'false'); });
      // Keep aria-hidden=false and overlay.is-open until the visual exit finishes.
      // The theme's critical CSS hides either immediately when these are removed.
      closingTimer = setTimeout(finishClose, reduced.matches ? 1 : 500);
    }
    triggers.forEach(function (el) {
      el.setAttribute('aria-controls', 'jb-search');
      el.setAttribute('aria-haspopup', 'dialog');
      listen(el, 'click', function (event) { event.preventDefault(); if (state === 'open') closeSearch(); else openSearch(el); });
    });
    listen(document.getElementById('jb-search-close'), 'click', function () { closeSearch(); });
    listen(overlay, 'click', function () { closeSearch(); });
    listen(panel, 'transitionend', function (event) {
      if (event.target === panel && state === 'open' && document.activeElement === opener) {
        (mobile.matches ? panel : input).focus({ preventScroll: true });
      }
    });
    listen(document, 'keydown', function (event) {
      if (state !== 'open') return;
      if (event.key === 'Escape') { event.preventDefault(); closeSearch(); return; }
      if (event.key === 'Tab') {
        var focusable = Array.from(panel.querySelectorAll('a[href], button, input:not([type="hidden"])')).filter(function (el) { return !el.disabled && el.getClientRects().length; });
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
      }
    });
    listen(input, 'keydown', function (event) {
      if (event.key === 'ArrowDown') {
        var first = (results.hidden ? defaults : results).querySelector('a[href]');
        if (first) { event.preventDefault(); first.focus(); }
      }
    });
    ['jb:menu-open','jb:panel-open','jb:contact-open','jb:request-open','panel:open'].forEach(function (name) { listen(document, name, function () { closeSearch(false); }); });
    listen(window, 'pagehide', function () { closeSearch(false); finishClose(); });
    listen(window, 'resize', syncPosition);
    var headerObserver = window.ResizeObserver && header ? new ResizeObserver(function () { if (state !== 'closed') syncPosition(); }) : null;
    if (headerObserver) headerObserver.observe(header);
    listen(form, 'submit', function (event) {
      var query = input.value.trim();
      if (!query) { event.preventDefault(); input.focus(); return; }
      input.value = query; remember(query);
    });
    listen(results, 'click', function (event) { if (event.target.closest('a')) remember(input.value.trim()); });
    listen(document.getElementById('jb-search-clear-history'), 'click', function () {
      try { localStorage.removeItem(historyKey); } catch (_) { /* Optional persistence. */ }
      animateContent(function () { historyEl.hidden = true; historyLinks.replaceChildren(); });
      input.focus();
    });
    function queueSearch() {
      var query = input.value.trim();
      clearTimeout(debounceTimer); cancelRequest();
      if (!query) { lastQuery = ''; showDefault(); return; }
      historyEl.hidden = true;
      if (query === lastQuery && !results.hidden) return;
      lastQuery = query;
      debounceTimer = setTimeout(function () { fetchPredictive(query); }, 220);
    }
    listen(input, 'input', queueSearch);
    function fetchPredictive(query) {
      if (state !== 'open') return;
      var current = { controller: new AbortController(), timedOut: false };
      request = current;
      progress.hidden = false; panel.setAttribute('aria-busy', 'true');
      current.timer = setTimeout(function () { current.timedOut = true; current.controller.abort(); }, 10000);
      fetch(predictiveUrl + '.json?q=' + encodeURIComponent(query) + '&resources[type]=product,collection,page,article&resources[limit]=4&resources[limit_scope]=each', { signal: current.controller.signal, credentials: 'same-origin' })
        .then(function (response) { if (!response.ok) throw new Error('Search unavailable'); return response.json(); })
        .then(function (data) {
          if (current !== request || state !== 'open' || input.value.trim() !== query) return;
          animateContent(function () { renderResults(data, query); defaults.hidden = true; results.hidden = false; });
        })
        .catch(function (error) {
          if (current !== request || state !== 'open' || input.value.trim() !== query || (error.name === 'AbortError' && !current.timedOut)) return;
          animateContent(function () {
            columns.innerHTML = '<p class="jb-search__message">Suggestions are temporarily unavailable. View all results below.</p>';
            creations.hidden = true; productsEl.replaceChildren(); more.href = urlFor(query);
            defaults.hidden = true; results.hidden = false;
          });
          status.textContent = 'Suggestions are unavailable. You can still view all results.';
          lastQuery = '';
        })
        .finally(function () { clearTimeout(current.timer); if (request === current) { request = null; progress.hidden = true; panel.removeAttribute('aria-busy'); } });
    }
    function configured(id) {
      return Array.from(document.querySelectorAll('#' + id + ' a')).map(function (el) { return { title: el.textContent.trim(), url: el.getAttribute('href') }; });
    }
    var categories = configured('jb-search-categories');
    var collections = configured('jb-search-collections');
    function resourcePath(value) {
      var safe = safeUrl(value);
      return safe ? new URL(safe, window.location.origin).pathname.replace(/\/$/, '') : '';
    }
    function group(title, items, query) {
      var links = items.map(function (item) {
        var url = safeUrl(item.url);
        return url ? '<li><a href="' + esc(url) + '">' + highlight(item.title, query) + '</a></li>' : '';
      }).join('');
      return '<div class="jb-search__column"><h3 class="jb-search__col-title">' + title + '</h3><ul class="jb-search__col-list">' + links + '</ul></div>';
    }
    function priceText(product) {
      var amount = Number(product.price);
      if (!Number.isFinite(amount)) return '';
      if (amount === 0) return 'Price upon request';
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: panel.dataset.currency || 'USD' }).format(amount); }
      catch (_) { return amount.toFixed(2); }
    }
    function renderResults(data, query) {
      var found = (data.resources || {}).results || {};
      var products = (found.products || []).slice(0, 4);
      var matches = function (item) {
        var title = item.title.toLowerCase(), term = query.toLowerCase();
        return title.startsWith(term) || title.split(/[\s&/–—-]+/).some(function (word) { return word.startsWith(term); });
      };
      var cats = categories.filter(matches);
      var collectionItems = collections.filter(matches);
      (found.collections || []).forEach(function (item) {
        if (!categories.some(function (c) { return resourcePath(c.url) === resourcePath(item.url); }) && !collectionItems.some(function (c) { return resourcePath(c.url) === resourcePath(item.url); })) collectionItems.push(item);
      });
      var pages = found.pages || [], articles = found.articles || [];
      var any = products.length + cats.length + collectionItems.length + pages.length + articles.length;
      columns.innerHTML = any ? group('Categories', cats, query) + group('Collections', collectionItems, query) + (articles.length ? group('Articles', articles, query) : '') + (pages.length ? group('Pages', pages, query) : '') : '<p class="jb-search__message">No results for “' + esc(query) + '”. Try another word or explore our creations.</p>';
      creations.hidden = !products.length;
      productsEl.innerHTML = products.map(function (product) {
        var url = safeUrl(product.url);
        if (!url) return '';
        var productUrl = new URL(url, window.location.origin); productUrl.searchParams.set('view', 'jb');
        var image = product.featured_image && product.featured_image.url || product.image || '';
        if (!/^(https?:)?\/\//.test(image)) image = '';
        return '<a href="' + esc(productUrl.pathname + productUrl.search) + '" class="jb-search__product-card"><div class="jb-search__product-img">' + (image ? '<img src="' + esc(image) + '" alt="" width="100" height="100" decoding="async">' : '') + '</div><p class="jb-search__product-name">' + esc(product.title) + '</p><p class="jb-search__product-price">' + esc(priceText(product)) + '</p></a>';
      }).join('');
      more.href = urlFor(query);
      status.textContent = any ? products.length + ' creations and ' + (cats.length + collectionItems.length + pages.length + articles.length) + ' related suggestions for ' + query : 'No results for ' + query;
    }
    disposeSearch = function () {
      clearTimeout(debounceTimer); clearTimeout(closingTimer); cancelRequest();
      if (contentAnimation) contentAnimation.cancel();
      if (headerObserver) headerObserver.disconnect();
      if (state === 'open') closeSearch(false);
      finishClose(); clearTimeout(closingTimer);
      if (headerSurface) headerSurface.remove();
      lifecycle.abort(); disposeSearch = null;
    };
    listen(document, 'shopify:section:unload', function (event) { if (event.target.contains(panel)) disposeSearch(); });
  }
  initializeSearch();
  document.addEventListener('shopify:section:load', function (event) { if (event.target.querySelector('#jb-search')) initializeSearch(); });
})();
